import { convertCmToIn } from '@pelicargo/utils';
import { useEffect, useState } from 'react';

import { trpc, TrpcOutputs } from '../../config/trpc';

type CargoOutput = TrpcOutputs['createCargo'];

const formatCargo = (data: CargoOutput): CargoOutput => ({
  ...data,
  length: convertCmToIn(data.length),
  width: convertCmToIn(data.width),
  height: convertCmToIn(data.height),
});

export const useCargos = (requestId?: number) => {
  const [cargos, setCargos] = useState<CargoOutput[]>([]);
  const { data, isLoading, error } = trpc.getCargosByRequestId.useQuery({ requestId }, { refetchOnWindowFocus: false });

  useEffect(() => {
    if (data) {
      const nextCargos = data?.map(formatCargo);
      setCargos(nextCargos);
    }
  }, [data]);

  trpc.onCargoCreated.useSubscription(
    { requestId },
    {
      onData: (data) => {
        setCargos((prev) => [...prev, formatCargo(data)]);
      },
    },
  );

  trpc.onCargoUpdated.useSubscription(
    { requestId },
    {
      onData: (data) => {
        setCargos((prev) =>
          prev.map((cargo) => {
            if (cargo.id === data.id) return formatCargo(data);
            return cargo;
          }),
        );
      },
      onError: (error) => {
        console.log('onCargoUpdated.error: ', error);
      },
    },
  );

  trpc.onCargoDeleted.useSubscription(
    { requestId },
    {
      onData: (deletedId) => {
        setCargos((prev) => prev.filter((cargo) => cargo.id !== deletedId));
      },
      onError: (error) => {
        console.log('onCargoDeleted.error: ', error);
      },
    },
  );

  return [cargos, isLoading, error?.message] as const;
};
